<template>
  <section class="qrs-typography">
    <pageHeader>
      <h2 class="qrs-header-xl mt--0 mb--0">My wellbeing diary</h2>
    </pageHeader>
    <div v-if="loading">
      <div class="loader"></div>
      <p class="loading__text">Loading...</p>
    </div>

    <div v-else class="message-success__panel">
      <div class="message-success__panel__content">
        <!-- <img alt="Check circle icon" src="../../assets/img/check_circle.png" /> -->
        <h3><strong>Wellbeing diary updated.</strong></h3>
        <p>You will now be able to add to and edit your wellbeing diary.</p>

        <button
          name="continue"
          aria-label="continue"
          class="govuk-button"
          title="Continue to My Symptom diary"
          @click="continueToDiary()"
        >
          Continue <span class="screen-reader-text">to my Symptom diary</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "entryAdded",
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    continueToDiary() {
      this.loading = !false;
      setTimeout(() => {
        this.loading = !true;
        this.$parent.goTo(this.$MyWellbeingDiary);
      }, 1500);
    },
  },
};
</script>